import React, { useState, useEffect, useRef } from "react";

export default function Countdown({ targetDate, onTenSecondMark }) {
  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(targetDate));
  const hasTriggeredRef = useRef(false);
  // const [showFilter, setShowFilter] = useState(false);
  // const [showDetails, setShowDetails] = useState(false);

  function calculateTimeLeft(date) {
    const target = new Date(date);
    if (isNaN(target)) return null;

    const difference = target - new Date();
    if (difference <= 0) return null;

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  useEffect(() => {
    if (!targetDate) return;

    hasTriggeredRef.current = false;

    const timer = setInterval(() => {
      const updated = calculateTimeLeft(targetDate);
      setTimeLeft(updated);

      if (!updated) {
        clearInterval(timer);
        return;
      }

      const totalSeconds =
        updated.days * 86400 +
        updated.hours * 3600 +
        updated.minutes * 60 +
        updated.seconds;

      if (totalSeconds <= 1800 && !hasTriggeredRef.current) {
        hasTriggeredRef.current = true;
        if (typeof onTenSecondMark === "function") {
          onTenSecondMark();
        }
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate, onTenSecondMark]);

  if (!timeLeft) return <p>Launched or no upcoming launch.</p>;

  return (
    <div className="text-center font-orbitron">
      {timeLeft.days}D : {timeLeft.hours}H : {timeLeft.minutes}M : {timeLeft.seconds}S
    </div>
  );
}
